/*jshint esversion: 6 */
const url = import.meta.env.VITE_APP_TARIFFS_API_URL;

// WIS API proxied via tariffs backend
export let countryProfileService = {
    getCountry: async (numericCountryCode) => {
        const response = await fetch(
            `${url}api/country-profiles/1.0/countries/${numericCountryCode}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return await response.json();
    },
};
